/**** session clear when user enter from menue start  ****/
jQuery(".header__menu-item").click(function() {
  localStorage.clear();
});

jQuery(".mega-menu__link").click(function() {
  localStorage.clear();
});
